import React from "react";
import styles from './Foerderverein.module.css';
import SubMenu from "../base/SubMenu";
import foerderverein from "./assets/foerder.png";

export const Foerderverein = () => {

    const mitgliedschaftRef = React.createRef()
    const sponsorenRef = React.createRef()
    const kontaktRef = React.createRef()
    const impressumRef = React.createRef()

    return(
        <React.Fragment>

            <React.Fragment>
                <SubMenu model={{
                    background: "#e7f2ff",
                    items: [
                        { label: "Start", onClick: () => window.location.href = "/foerderverein"},
                        { label: "Mitgliedschaft", onClick: () => mitgliedschaftRef.current.scrollIntoView()},
                        { label: "Sponsoren", onClick: () => sponsorenRef.current.scrollIntoView()},
                        { label: "Kontakt", onClick: () => kontaktRef.current.scrollIntoView()},
                        { label: "Impressum", onClick: () => impressumRef.current.scrollIntoView()}
                    ]
                }}/>


                <div className={styles.hero} style={{ backgroundImage: `url(${foerderverein})` }} />



                <div className="wrapper">
                    <div className="wrapperContent">
                    <div className={styles.text}>
                        <h1>FÖRDERVEREIN</h1>

                       <p>
                           Der Schulförderverein „Freunde und Förderer der Interkulturellen Schule Rhein-Main e. V.“ setzt sich für Respekt, gegenseitiges Verständnis und Dialog ein und unterstützt die Schule in Bildung, Erziehung und konstruktiver Arbeit.
                       </p>
                       <p>
                           Dank Eurer tatkräftigen Mitwirkung und großartigen Spenden können wir viele Aktionen ins Leben rufen und unsere Schule bei der Umsetzung schulinterner Projekte konstruktiv zur Seite stehen.
                       </p>
                       <p>
                           Hier finden Sie Informationen über den Verein und aktuelle und geplante Aktionen, Projekte und Veranstaltungen. Wir freuen uns auf Ideen und Vorschläge sowie über die konstruktive Zusammenarbeit!
                       </p>
                       <p>
                           Euer Schulförderverein
                       </p>
                       </div>
                    </div>

                </div>

                <div ref={mitgliedschaftRef} style={{paddingTop: 'calc(var(--header-height))'}}><MitgliedschaftForm/></div>
                <div ref={sponsorenRef} style={{paddingTop: 'calc(var(--header-height))'}}><SponsorenForm/></div>
                <div ref={kontaktRef} style={{paddingTop: 'calc(var(--header-height))'}}><KontaktForm/></div>
                <div ref={impressumRef} style={{paddingTop: 'calc(var(--header-height))'}}><ImpressumForm/></div>
            </React.Fragment>
        </React.Fragment>
    );
};

const MitgliedschaftForm = () => {
    const pdfUrl = '/assets/Aufnahmeantrag IKS-Förderverein_2023.pdf';
    return (
        <React.Fragment>
            <div style={{backgroundColor: '#548bf1'}}>
                <div className={styles.darkBackground + ' wrapper wrapperContent'}>
                    <h1>MITGLIED WERDEN!</h1>
                    <h2>Nur noch wenige Schritte zur Mitgliedschaft!</h2>
                    <p>Wir würden uns freuen, Sie in unserem Verein als neues Mitglied begrüßen zu dürfen.

                        Auch in Zukunft werden wir uns bemühen, eine familienfreundliche Beitragsgestaltung beizubehalten, so wie Sie es zu Recht von uns erwarten dürfen.</p>
                    <div>

                        <a href={pdfUrl} download="Aufnahmeantrag IKS-Förderverein_2023.pdf" style={{textDecoration: 'none', color: '#FFFFFF', fontSize: '24px'}}>

                            <div className="grid">
                                <div style={{width: 100}}>
                                    <img src={require("./assets/pdf.webp")} alt="Foerderverein" />
                                </div>
                                <div className="col">
                                    <div style={{fontSize: '32px', fontWeight: 'bold'}}>Beitrittserklärung</div>
                                    <div>
                                        (Aufnahmeantrag IKS-Förderverein.pdf)
                                    </div>
                                </div>
                            </div>
                        </a>

                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const SponsorenForm = () => {
    return (
        <div className="wrapper wrapperContent">
            <div className={styles.text}>
                <h1>SPONSOR WERDEN!</h1>
                <h2>Sponsoren</h2>
                <p>
                    Ein Verein lebt wesentlich von seinen Mitgliedern, deren Engagement und Begeisterung. Umso mehr schätzen wir die vielen Sponsoren und Gönner, die mit ihrer Unterstützung dafür sorgen, dass ein aktives Vereinsleben möglich ist. Nur dem großzügigen Engagement und der freundschaftlichen Verbundenheit mit regionalen Partnern ist es zu verdanken, dass die Jugendarbeit weiter gestärkt werden kann und immer wieder Hervorragendes geleistet wird.
                </p>
                <p>
                    Wir sagen daher allen Unterstützern ein herzliches Dankeschön und sind stolz darauf, tolle Partner und Sponsoren an unserer Seite zu wissen.
                </p>
            </div>
        </div>
    );
};

const KontaktForm = () => {
    return (
        <div style={{backgroundColor: '#25b55f'}}>
            <div className={styles.darkBackground + ' wrapper wrapperContent'}>
                <div>
                    <h2>Kontakt</h2>
                    <p>Freunde und Förderer der Interkulturellen Schule Rhein-Main e. V.</p>
                    <p>Kaiserkronenweg 1</p>
                    <p>60433 Frankfurt</p>
                    <p>E-Mail: <a href="mailto:info@sfv-iks.de">info@sfv-iks.de</a></p>
                </div>
            </div>
        </div>
    );
};

const ImpressumForm = () => {
    return (
        <div className="wrapper wrapperContent">
            <div className={styles.text}>
                <h2>Impressum</h2>
                <p>Kontakt: <br/>
                    Freunde und Förderer der Interkulturellen Schule Rhein-Main e. V.<br/>
                    Kaiserkronenweg 1<br/>
                    60433 Frankfurt<br/>
                    E-Mail: <a href="mailto:info@sfv-iks.de">info@sfv-iks.de</a><br/>
                    Vereinsregister: Amtsgericht Frankfurt am Main
                    <br/>
                    Registernummer: VR17086</p>
            </div>
        </div>
    );
};

export default Foerderverein;

